interface Props {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: Props) {
  if (total <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || Math.abs(i - current) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "…") {
      pages.push("…");
    }
  }

  const baseBtn =
    "min-w-9 h-9 px-3 flex items-center justify-center rounded-md text-sm border transition-colors cursor-pointer whitespace-nowrap";

  return (
    <nav className="flex items-center justify-center gap-2 mt-8" aria-label="分页导航">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className={`${baseBtn} border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-left-s-line" />
        <span className="hidden sm:inline">上一页</span>
      </button>

      {pages.map((p, i) =>
        typeof p === "number" ? (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`${baseBtn} ${
              p === current
                ? "border-primary-600 bg-primary-600 text-background-50 font-medium"
                : "border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300"
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={`ellipsis-${i}`} className="px-1 text-foreground-400">
            …
          </span>
        ),
      )}

      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className={`${baseBtn} border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <span className="hidden sm:inline">下一页</span>
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}